<template>
  <div id="_2025_2">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h">
          Call for Nominations - IGU Outstanding Achievement Award and
          Excellent Young Scholar Award in
          Modeling Geographical Systems (2025)
        </strong>
      </h3>
      <hr />
      <p>
        The <strong>IGU Outstanding Achievement Award and Excellent Young Scholar
        Award in Modeling Geographical Systems (OAA 2025 and YSA 2025)</strong>
        are receiving nominations to recognize researchers for long and
        meritorious contributions to the community of geographic modeling
        research or young researchers for meritorious academic contributions
        in their early career. An awards committee will be organized by IGU
        through its Modeling Geographical Systems Commission (IGU MGSC), and
        it will solicit and evaluate the nominees and present the awards to
        the individuals in light of their excellent scientific achievements
        and contributions.
      </p>
      <div>
        <h5>Eligibility</h5>
        <ul>
          <li>Nominees for the OAA 2025 are expected to have outstanding research
            contributions to geographic modeling and relevant fields.</li>
          <li>Nominees for the YSA 2025 should have received a doctoral degree in
            the last seven years (no earlier than 2018) and have significant
            research contributions to geographic modeling and relevant fields.</li>
          <li>Nominees for the YSA 2025 also should be IGU MGSC members.</li>
        </ul>
      </div>
      <div>
        <h5>Award Benefits</h5>
        <p>The award committee will select one awardee for OAA 2025, and the awardee will receive an award certificate and cash prizes (USD $500).</p>
        <p>The award committee will select two awardees for YSA 2025, and each awardee will receive an award certificate and cash prizes (USD $300).</p>
      </div>
      <div>
        <h5>Submission Instructions</h5>
        To nominate an award for OAA 2025, please submit the following documents as PDF files:
        <ul>
          <li><strong>Nomination Letter</strong>: A personal statement is needed to describe the nominee’s contributions and achievements. The statement should be no more than 500 words.</li>
          <li><strong>Curriculum Vitae or Resume</strong>: The latest curriculum vitae or resume of nominees.</li>
        </ul>
        To nominate an award for YSA 2025, please submit the following documents as PDF files:
        <ul>
          <li><strong>Nomination Letter</strong>: A personal statement is needed to describe the nominee’s contributions and achievements. The statement should be no more than 500 words.</li>
          <li><strong>Curriculum Vitae or Resume</strong>: The latest curriculum vitae or resume of nominees.</li>
          <li><strong>Certificate of Academic Degree</strong>: The certificate can prove the eligibility of nominees.</li>
          <li><strong>Two Recommendation Letter</strong>: The recommender must have a formal professional role that allows them to assess the nominee’s achievements, current academic status and progress. The recommendation letter should be signed by the recommenders. Once prepared, the letter should be converted to a PDF format.</li>
        </ul>
      </div>
      <p>
        The Nomination Letter Template can be found under the “Awards” page of the official website of IGU MGSC (http://www.igu-geomodeling.com/Awards).
      </p>
      <p>
        Nominators or nominees need to merge the mentioned documents into a single PDF file.
        Please submit the PDF file to Secretary General of MGSC, Prof. Wei Luo (geowl@nus.edu.sg), and cc to Dr. Zaiyang Ma (mazaiyang@njnu.edu.cn),
        including “IGU MGSC Outstanding Achievement Award” or “IGU MGSC Excellent Young Scholar Award” in the email subject line. (<strong>Self-nominations are not accepted.</strong>)
      </p>

      <h5>Important date</h5>
        The tentative dates for submission and notifications are as follows.
        <ul>
          <li>Deadline for submission: October 15, 2025</li>
          <li>Deadline for notification to the awardee: November 30, 2025</li>
        </ul>
      <h5>Contact</h5>
      <p>Prof. Wei Luo: geowl@nus.edu.sg <br>
        Dr. Zaiyang Ma: mazaiyang@njnu.edu.cn</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2025_2'
};
</script>
<style scoped lang="less">
#_2025_2 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}
h5 {
  font-weight: bold;
}
.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}

.pic {
  // display: table-cell;
  text-align: center;
  height: 128px;
  width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  // justify-content: center;
}
</style>
